// extracted by mini-css-extract-plugin
module.exports = {"root":"Welcome_root__npbLW"};